<div class="w-full center">
	<div class="loader"></div>
</div>
